import zenObservable from 'zen-observable';

var Observable = zenObservable;

export default Observable;
export { Observable };
//# sourceMappingURL=bundle.esm.js.map



//////////////////
// WEBPACK FOOTER
// ../app_shared/~/apollo-link-context/~/zen-observable-ts/lib/bundle.esm.js
// module id = 147
// module chunks = 1